import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Option } from '@spike/model';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';
import Tag from './Tag';

export interface TagsProps {
    options: Array<Option<string>>;
    blockedClient: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            width: '100%',
            flexWrap: 'wrap'
        },
        tag: {
            margin: '3px 8px 3px 0px'
        }
    })
);

export const Tags: FunctionComponent<TagsProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.container, props.className)}>
            {props.blockedClient && (
                <Tag
                    color="#EF4F57"
                    className={classes.tag}
                >
                    Blocked
                </Tag>
            )}
            {props.options.map(option => (
                <Tag
                    key={option.id}
                    className={classes.tag}
                >
                    {option.name}
                </Tag>
            ))}
        </Box>
    );
};

export default Tags;
